import apiClient from '../../utils/apiClient';
import UtilsService from './UtilsService';

class QRService {
  generateUniqueToken() {
    return UtilsService.generateUniqueId();
  }

  async registerToken(eventDbId, token, methods) {
    const response = await apiClient.post(`/attendance/${eventDbId}/generate-link/`, { 
      token,
      methods,
      eventId: eventDbId
    });
    
    const data = await response.json();
    
    if (response.ok) {
      return data;
    }
    
    const errorMessage = data.message || data.error || `Error al registrar token: ${response.status}`;
    throw new Error(errorMessage);
  }

  async generateQRCode(eventDbId, token) {
    const response = await apiClient.post(`/attendance/${eventDbId}/generate-qr/`, { 
      token,
      frontendUrl: window.location.origin
    });
    
    const data = await response.json();
    
    if (response.ok) {
      return data;
    }
    
    const errorMessage = data.message || data.error || `Error al generar QR: ${response.status}`;
    throw new Error(errorMessage);
  }

  generateAttendanceLink(eventDbId, token) {
    const baseUrl = window.location.origin;
    return `${baseUrl}/#/attendance/${eventDbId}?token=${token}`;
  }

  async generateLinkCredentials(eventDbId, eventTitle, methods) {
    const token = this.generateUniqueToken();
    
    await this.registerToken(eventDbId, token, methods);
    
    return {
      url: this.generateAttendanceLink(eventDbId, token),
      token,
      eventTitle,
      eventId: eventDbId
    };
  }

  async generateQRCredentials(eventDbId, eventTitle, methods) {
    const token = this.generateUniqueToken();
    
    await this.registerToken(eventDbId, token, methods);
    
    const qrData = await this.generateQRCode(eventDbId, token);
    
    if (qrData.success) {
      return {
        qrCodeImage: qrData.qr_code,
        url: qrData.attendance_url,
        token,
        eventTitle,
        eventId: eventDbId
      };
    }
    
    throw new Error(qrData.message || 'Error al generar QR');
  }

  async generateBothCredentials(eventDbId, eventTitle) {
    // Una sola llamada - el backend maneja la lógica de get-or-create
    const response = await apiClient.post(`/attendance/${eventDbId}/get-or-create-token/`, {
      eventTitle,
      methods: ['Link', 'QR']
    });
    
    const data = await response.json();
    
    if (!response.ok || !data.success) {
      const errorMessage = data.message || data.error || `Error al obtener token: ${response.status}`;
      throw new Error(errorMessage);
    }
    
    const token = data.token;
    console.log(data.created ? 'Nuevo token creado:' : 'Token existente reutilizado:', token);
    
    const attendanceUrl = this.generateAttendanceLink(eventDbId, token);
    
    const qrData = await this.generateQRCode(eventDbId, token);
    
    return {
      link: {
        url: attendanceUrl,
        token,
        eventTitle,
        eventId: eventDbId
      },
      qr: qrData.success ? {
        qrCodeImage: qrData.qr_code,
        url: qrData.attendance_url,
        token,
        eventTitle,
        eventId: eventDbId
      } : null
    };
  }

  async copyToClipboard(text) {
    return await UtilsService.copyToClipboard(text);
  }

  downloadQRImage(qrCodeImage, eventTitle) {
    return UtilsService.downloadQRImage(qrCodeImage, eventTitle);
  }
}

export default new QRService();